import { useEffect, useRef } from "react";
import { SlokaSoundBlock } from "@/components/chanting/SlokaSoundBlock";

function pickActiveIndex(slides, currentSeconds) {
  if (!slides?.length) return 0;
  let idx = 0;
  for (let i = 0; i < slides.length; i++) {
    if ((slides[i].timestamp ?? 0) <= currentSeconds) idx = i;
    else break;
  }
  return idx;
}

/**
 * Auto-scrolling sloka panel — Sanskrit + transliteration (sound), no meanings.
 */
export function ScrollingSlokaPanel({ slides, currentSeconds = 0, language, className = "" }) {
  const containerRef = useRef(null);
  const activeIdx = pickActiveIndex(slides, currentSeconds);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const active = container.querySelector(`[data-slide-idx="${activeIdx}"]`);
    active?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [activeIdx]);

  if (!slides?.length) {
    return (
      <div
        className={`rounded-lg border bg-white/80 p-6 text-center text-muted-foreground text-sm ${className}`}
        data-testid="scrolling-sloka-empty"
      >
        No sloka text available yet. Admins can add Sanskrit + transliteration via Edit.
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className={`rounded-lg border border-amber-200/60 bg-white/90 max-h-72 overflow-y-auto scroll-smooth ${className}`}
      data-testid="scrolling-sloka-panel"
    >
      {slides.map((slide, idx) => {
        const active = idx === activeIdx;
        return (
          <div
            key={`${slide.timestamp}-${idx}`}
            data-slide-idx={idx}
            className={`px-4 py-3 border-b last:border-b-0 transition-colors ${
              active ? "bg-amber-50/90 border-l-4 border-l-amber-500" : "opacity-70"
            }`}
          >
            <SlokaSoundBlock slide={slide} language={language} />
          </div>
        );
      })}
    </div>
  );
}
